module.exports = __webpack_public_path__ + "static/img/harddevelop2.bbcccc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/hard/harddevelop2.jpg
// module id = Lkf6
// module chunks = 0